module.exports = __webpack_public_path__ + "static/handShake.f8ae60ed.png";